<template>
    <div ref="noticeContainerRef">
        <div style="margin-left:20px">
            <div class="label">
                <span style="color:red;">*</span> 
                {{ $t('notice.relateApp') }}
            </div>
            <a-select
                ref="select"
                v-model:value="formState.app_id"
                style="width: 860px;"
                :options="appOptions"
                placeholder="请选择"
                @focus="focus"
                @change="handleSelectChange('app')"
            ></a-select>
        </div>

        <div style="margin-top: 20px;">
            <div style="margin-left:20px; display: inline-block;">
                <div class="label">
                    <span style="color:red;">*</span> 客户
                </div>
                <a-select
                    ref="select"
                    v-model:value="formState.customer_code"
                    style="width: 200px;"
                    :options="customerOptions"
                    placeholder="请选择"
                    @focus="focus"
                    @change="(value)=>handleSelectChange('customer', value)"
                ></a-select>
            </div>

            <div style="margin-left:20px;display: inline-block;">
                <div class="label">
                    <span style="color:red;">*</span> 车厂
                </div>
                <a-select
                    ref="select"
                    v-model:value="formState.manufacturer_code"
                    style="width: 200px;"
                    :options="factoryOptions"
                    placeholder="请选择"
                    @focus="focus"
                    @change="(value)=>handleSelectChange('factory', value)"
                ></a-select>
            </div>

            <div style="margin-left:20px;display: inline-block;">
                <div class="label">
                    <span style="color:red;">*</span> 车型
                </div>
                <a-select
                    ref="select"
                    v-model:value="formState.model_code"
                    style="width: 200px;"
                    :options="modelOptions"
                    placeholder="请选择"
                    @focus="focus"
                    @change="(value)=>handleSelectChange('model', value)"
                ></a-select>
            </div>

            <div style="margin-left:20px;display: inline-block;">
                <div class="label">
                    <span style="color:red;">*</span> 硬件平台
                </div>
                <a-select
                    ref="select"
                    v-model:value="formState.hardware_platform_code"
                    style="width: 200px;"
                    :options="hardwareOptions"
                    placeholder="请选择"
                    @focus="focus"
                    @change="(value)=>handleSelectChange('hardware', value)"
                ></a-select>
            </div>
            
        </div>

        

        <div style="margin:20px 0 0 20px">
            <div class="label">
                <span style="color:red;">*</span> 
                {{ $t('notice.notice_title2') }}
            </div>
            <a-input v-model:value="formState.notice_title" :maxlength="100" style="width: 860px" placeholder="请输入" />
        </div>

        <!-- 富文本 -->
        <div id="aiEditor" ref="divRef" style="height: 550px;  margin: 20px"></div>

        <div style="width: 100%;text-align:center;padding-bottom: 50px;">
            <a-button size="middle" class="operate_btn" style="margin-right:20px;" @click="handle('cancel')" >
                {{$t('base.cancel')}}
            </a-button>
            <a-button type="primary" size="middle" class="operate_btn" :disabled="!formState.app_id && formState.notice_title != '' && html != '<p></p>'" @click="handle('save')" >
                {{$t('base.save')}}
            </a-button>
        </div>

        <!-- 预览 确认发布 -->
        <a-modal 
            v-model:visible="visible" 
            :title="t('notice.releaseNotice')" 
            width="800px"
            style="height:400px"
            okText="发布"
            :getContainer="getContainer"
            @cancel="handleCancel"
            @ok="handleOk"
        >
            <div class="addTitle">{{ formState.notice_title }}</div>
            <div v-html="html"></div>
        </a-modal>
        
    </div>
</template>

<script setup>
    import { onMounted, onUnmounted, ref, reactive, createVNode, watch } from "vue";
    import { useRouter } from "vue-router";
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { NoticeApi } from '@/api/NoticeApi.js'; 
    import { SmallProgramApi } from '@/api/SmallProgramApi.js';
    import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
    import { debounce } from 'lodash-es';
    import {AiEditor} from "aieditor";
    import "aieditor/dist/style.css"

    const { t } = useI18n()
    const router = useRouter()

    const GOBAOID = 'wx12360923facd605a' // 正式：wx0dc05f95f965d69a     测试：123456
    const userInfo = ref(JSON.parse(localStorage.getItem('hd_ota_loginUser')))
    let aiEditor = null
    const divRef = ref(null)
    const html = ref('')
    const visible = ref(false)
    const noticeContainerRef = ref(null)
    const formState = reactive({
        app_id: null,
        notice_title: '',
        notice_content: '',
        hardware_platform_code: '',
        model_code: '',
        manufacturer_code: '',
        customer_code: '',
    })
    // const file_nos = ref([])
    const appOptions = ref([])
    const customerOptions = ref([])
    const factoryOptions = ref([])
    const modelOptions = ref([])
    const hardwareOptions = ref([])


    const handle = (type)=>{
        switch(type){
            case 'cancel':
                Modal.confirm({
                    title: '提示',
                    icon: createVNode(ExclamationCircleOutlined),
                    content:'是否确认取消?',
                    okText: t('base.yes'),
                    cancelText: t('base.no'),
                    onOk() {
                        router.push({path:'/Notice/List'})
                    },
                });
                break;
            case 'save':
                html.value = aiEditor.getHtml()
                console.log(html.value,'html', formState)

                if(!formState.app_id){
                    message.error('请选择小程序名称！')
                    return
                }else if(formState.customer_code === ''){
                    message.error('请选择客户编码！')
                    return
                }else if(formState.hardware_platform_code === ''){
                    message.error('请选择硬件平台编码！')
                    return
                }else if(formState.manufacturer_code === ''){
                    message.error('请选择车厂编码！')
                    return
                }else if(formState.model_code === ''){
                    message.error('请选择车型编码！')
                    return
                }else if(formState.notice_title == ''){
                    message.error('请填写公告标题！')
                    return
                }

                if(html.value == '<p></p>'){
                    Modal.warning({
                        title: '提示',
                        icon: createVNode(ExclamationCircleOutlined),
                        content:'内容不能为空！',
                        okText: '确定',
                        onOk() {},
                    });
                }else{
                    visible.value = true
                }
                break;
        }
    }

    const getContainer = ()=>{
        return noticeContainerRef.value
    }

    const handleSelectChange = async(key, value)=>{
        if(key == 'app'){
            if(formState.app_id == GOBAOID){
                // getTreeList({app_id: formState.app_id}, '0')
                getCustomerList()
            }else{
                // await getTreeList({app_id: formState.app_id}, '0')
                getCustomerList()
                // formState.customer_code = customerOptions.value[0].value
                // handleSelectChange('customer', formState.customer_code)
            }
        }else if(key == 'customer'){
            if(formState.customer_code === -1){
                formState.hardware_platform_code = -1
                formState.manufacturer_code = -1
                formState.model_code = -1
                hardwareOptions.value = [{
                    label: '全部',
                    value: -1,
                }]
                factoryOptions.value = [{
                    label: '全部',
                    value: -1,
                }]
                modelOptions.value = [{
                    label: '全部',
                    value: -1,
                }]
            }else{
                getFactoryList()
                formState.hardware_platform_code = ''
                formState.manufacturer_code = ''
                formState.model_code = ''
                hardwareOptions.value = []
                factoryOptions.value = []
                modelOptions.value = []
            }
            
        }else if(key == 'factory'){
            if(formState.manufacturer_code === -1){
                formState.model_code = -1
                formState.hardware_platform_code = -1
                modelOptions.value = [{
                    label: '全部',
                    value: -1,
                }]
                hardwareOptions.value = [{
                    label: '全部',
                    value: -1,
                }]
            }else{
                formState.model_code = ''
                formState.hardware_platform_code = ''
                hardwareOptions.value = []
                modelOptions.value = []
                getModelList('3')
            }
        }else if(key == 'model'){
            if(formState.model_code === -1){
                formState.hardware_platform_code = -1
                hardwareOptions.value = [{
                    label: '全部',
                    value: -1,
                }]
            }else{    
                formState.hardware_platform_code = ''  
                getModelList('1')
                
            }
        }

        // else if(key == 'hardware'){
        //     if(formState.hardware_platform_code === -1){
        //         formState.manufacturer_code = -1
        //         formState.model_code = -1
        //         factoryOptions.value = [{
        //             label: '全部',
        //             value: -1,
        //         }]
        //         modelOptions.value = [{
        //             label: '全部',
        //             value: -1,
        //         }]
        //     }else{      
        //         getTreeList({
        //             app_id: formState.app_id, 
        //             customer_code: formState.customer_code, 
        //             hardware_platform_code: formState.hardware_platform_code
        //         }, '2')
        //         formState.manufacturer_code = ''
        //         formState.model_code = ''
        //     }
        // }
    }

    // 获取用户小程序名称
    const getAppNameList = async ()=> {
        console.log(userInfo.value.role_type,'role_type')
        let param = {
            status:0,
            app_id: userInfo.value.app_id,
        }
        let res = await SmallProgramApi.getInstance().getSmallProgramQuery(param)
        if (res.code == 0) {
            res.data.length > 0 && res.data.forEach(item=>{
                appOptions.value.push({
                    label: item.app_name,
                    value: item.app_id,
                })
            })
        } else {
            message.error(res.msg);
        }
    } 


    // 发布公告
    const handleOk = async ()=> {
        let param = {
            ...formState,
            customer_code: formState.customer_code == -1 ? '' : formState.customer_code,
            hardware_platform_code: formState.hardware_platform_code == -1 ? '' : formState.hardware_platform_code,
            manufacturer_code: formState.manufacturer_code == -1 ? '' : formState.manufacturer_code,
            model_code: formState.model_code == -1 ? '' : formState.model_code,
            notice_content: html.value,
        }
        let res = await NoticeApi.getInstance().addNotice(param)
        if (res.code == 0) {
            message.success('发布成功！');
            visible.value = false
            router.push({path:'/Notice/List'})
        } else if(res.code == '1243'){
            message.error('车厂编码不属于该小程序关联的硬件平台!');
        } else if(res.code == '1244'){
            message.error('车型编码不属于该小程序关联的车厂!');
        } else if(res.code == '1245'){
            message.error('硬件平台编码不属于该小程序关联的客户!');
        } else if(res.code == '1247'){
            message.error('客户不属于该小程序!');
        } else {
            message.error(res.msg);
        }
    } 


    // 获取客户、平台下拉数据
    const getCustomerList = async()=>{
        let param = {
            app_id: formState.app_id,
            dict_type: 0,
        }
        let res = await NoticeApi.getInstance().getCustomerList(param)
        if(res.code == 0){
            customerOptions.value = res.data.length > 0 && res.data.map(item=>({
                label: item.dict_name,
                value: item.dict_code,
                id: item.id,
            }))
            // if(formState.app_id == GOBAOID){
                customerOptions.value.unshift({
                    label: '全部',
                    value: -1,
                })
            // }
        }else{
            message.error(res.msg)
        }
    }

    // 获取车厂下拉数据
    const getFactoryList = async()=>{
        let param = {
            app_id: formState.app_id,
            customer_code: formState.customer_code,
        }
        let res = await NoticeApi.getInstance().getFactoryList(param)
        if(res.code == 0){
            factoryOptions.value = res.data.length > 0 && res.data.map(item=>({
                label: item.manufacturer_name,
                value: item.manufacturer_code,     
                id: item.id,
            }))
            factoryOptions.value.unshift({
                label: '全部',
                value: -1,
            })
        }else{
            message.error(res.msg)
        }
    }

    // 获取车型、硬件平台下拉数据
    const getModelList = async(type)=>{
        let param = {
            app_id: formState.app_id,
            customer_code: formState.customer_code,
            manufacturer_code: formState.manufacturer_code,
            model_code: formState.model_code,
        }
        let res = await NoticeApi.getInstance().getModelList(param)
        if(res.code == 0){
            if(type == '3'){
                modelOptions.value = res.data.length > 0 && res.data.map(item=>({
                    label: `${item.model_name}-${item.model_code}`,
                    value: item.model_code,
                    id: item.id,
                }))
                modelOptions.value.unshift({
                    label: '全部',
                    value: -1,
                })
            }else if(type == '1'){
                hardwareOptions.value = res.data.length > 0 && res.data.map(item=>({
                    label: item.hardware_platform_name,
                    value: item.hardware_platform_code,
                    id: item.id,
                }))
                hardwareOptions.value.unshift({
                    label: '全部',
                    value: -1,
                })
            }
            
        }else{
            message.error(res.msg)
        }
    }

    const getTreeList = async(param, type)=>{
        let res = await NoticeApi.getInstance().getTreeList(param)
        if(res.code == 0){
            if(type == '0'){
                customerOptions.value = res.data.length > 0 && res.data.map(item=>({
                    label: item.customer_name,
                    value: item.customer_code,
                    id: item.id,
                }))
                if(formState.app_id == GOBAOID){
                    customerOptions.value.unshift({
                        label: '全部',
                        value: -1,
                    })
                }
            }else if(type == '1'){
                hardwareOptions.value = res.data.length > 0 && res.data.map(item=>({
                    label: item.hardware_platform_name,
                    value: item.hardware_platform_code,
                    id: item.id,
                }))
                hardwareOptions.value.unshift({
                    label: '全部',
                    value: -1,
                })
            }else if(type == '2'){
                factoryOptions.value = res.data.length > 0 && res.data.map(item=>({
                    label: item.manufacturer_name,
                    value: item.manufacturer_code,     
                    id: item.id,
                }))
                factoryOptions.value.unshift({
                    label: '全部',
                    value: -1,
                })
            }else if(type == '3'){
                modelOptions.value = res.data.length > 0 && res.data.map(item=>({
                    label: item.model_name,
                    value: item.model_code,
                    id: item.id,
                }))
                modelOptions.value.unshift({
                    label: '全部',
                    value: -1,
                })
            }
        }else{
            message.error(res.msg)
        }
    }
    

    onMounted(() => {
        getAppNameList()
        

        // 初始化富文本
        aiEditor = new AiEditor({
            element: divRef.value,
            placeholder: "点击输入内容...",
            content: '',
            // theme: "dark",
            draggable:false,
            pasteAsText:true,
            // textCounter:false,
            toolbarKeys: ["undo", "redo", "brush", "eraser",
                "|", "heading", "font-family", "font-size",
                "|", "bold", "italic", "underline", "strike", "link", "subscript", "superscript", "hr", "todo", "emoji",
                "|", "highlight", "font-color",
                "|", "align", "line-height",
                "|", "bullet-list", "ordered-list", "indent-decrease", "indent-increase", "break",
                "|", "image", "quote",
                "|", "fullscreen"
            ],
            textSelectionBubbleMenu: {
                enable: true,
                items: ["Bold", "Italic", "Underline", "Strike"],
            },
            image: {
                allowBase64: false,
                defaultSize: 200,
                uploadUrl: import.meta.env.VITE_BASE_URL + `/vl/page/file/pictures/upload`,
                // uploadFormName: "image", //上传时的文件表单名称
                uploadHeaders: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': 'Bearer ' + 'eyJ0eXBlIjoiSldUIiwiYWxnIjoiSFM1MTIifQ.eyJzdWIiOiJhZG1pbiIsInVzZXJfbmFtZSI6ImFkbWluIiwibW9iaWxlIjpudWxsLCJpZCI6NSwiZXhwIjoxNzU3OTE2MDk2LCJpYXQiOjE3NDIwMTg0OTYsImp0aSI6IjM4MDM1NjY2ODIyNjk2MTQwOCIsInRpbWVzdGFtcCI6MTc0MTk1MTcxNH0.uQDKGm49VxYgdovf3ALglUkJFUJ1Cpy7vy_Mx283kGQqoT7XqX94ybwO4Faa6ltyIhI0ZRdmySqUUZvrzThiWg',
                },
                uploader: async (file) => {
                    const formData = new FormData()
                    formData.append('file', file)
                    let res = await NoticeApi.getInstance().uploadPicture(formData)
                    if(res.code == 0){
                        return res.data
                    }else{
                        message.eror(res.msg)
                    }
                },
                uploaderEvent: {
                    onUploadBefore: (file) => {
                        //监听图片上传之前，此方法可以不用回任何内容，但若返回 false，则终止上传
                        // console.log(file,'上传前')
                        let size = file.size / (1024 * 1024)
                        if(size > 10){
                            message.error('上传的图片不能超过10M！')
                            return false
                        }
                        // console.log(size,'szie')
                    },
                    onSuccess: (file, response) => {
                        //监听图片上传成功
                        // console.log(response,'上传成功')
                        // file_nos.value.push(response.file_no)
                        // console.log(file_nos.value,'文件号')

                        return {
                            "errorCode": 0,
                            "data": {
                                "src": response.download_path,
                                "height": "auto",
                                "loading": true,
                            }
                        }
                    },
                    onFailed: (file, response) => {
                        //监听图片上传失败，或者返回的 json 信息不正确
                        console.log(file, response,'上传失败')
                    },
                    onError: (file, error) => {
                        //监听图片上传错误，比如网络超时等
                        console.log(file, response,'上传错误')
                    },
                },
                bubbleMenuItems: ["AlignLeft", "AlignCenter", "AlignRight", "delete"]
            },
        })
    })

    

    onUnmounted(() => {
        aiEditor && aiEditor.destroy();
    })
</script>

<style lang="scss" scoped>
::v-deep .ant-modal-body{
    height: 600px;
    overflow-y: scroll;
}

.label{
    width: 120px;
}
.addTitle{
    margin-bottom: 20px;
    width: 100%;
    font-size: 17px;
    font-weight: 600;
    text-align: center;
}
</style>